import SoftPhoneModule from '@modules/SoftPhoneModule';
import { ChunkLoadErrorView } from './ChunkLoadErrorView';
import { useChunkLoadFailure } from './useChunkLoadFailure';

const reloadPage = () => window.location.reload();

const isOnCall = () => SoftPhoneModule.isAttemptingCall();

export interface ChunkLoadFailurePanelProps {
  /** The error thrown when the chunk failed to load. */
  error: unknown;
  /** Render inside the layout's content area instead of replacing the page. */
  inline?: boolean;
}

/**
 * Reports a chunk load failure and shows the matching message with a reload
 * action. Used by the router error page and, inline, by lazy routes so the
 * rest of the layout (nav bar, call bar) stays mounted.
 */
export const ChunkLoadFailurePanel = ({
  error,
  inline,
}: ChunkLoadFailurePanelProps) => {
  const reason = useChunkLoadFailure(error);

  return (
    <ChunkLoadErrorView
      reason={reason}
      onReload={reloadPage}
      isOnCall={isOnCall}
      inline={inline}
    />
  );
};
